import * as Sentry from '@sentry/vue';

export function setUser(user) {
    Sentry.setUser({
        id: user.id,
        username: user.username,
        email: user.email,
        ip_address: '{{auto}}',
        Permissions: user.permissions,
        Type: user.userType,
    });
}

export function setContext(name, data) {
    Sentry.setContext(name, data);
}

export default {
    setUser,
    setContext,
};
